module.exports = __webpack_public_path__ + "img/cognitive_img10.5d053d7e.png";